// ============================================================
// CONTEÚDO EDITÁVEL DO SITE — LIS SILVA DOULA
// Altere aqui textos, contatos, preços, serviços e imagens.
// ============================================================

export const CONTACT = {
  whatsappNumber: "5548991989534",
  instagramUrl: "https://www.instagram.com/lis.doula/",
  instagramHandle: "@lis.doula",
  city: "Florianópolis",
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsappNumber}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;

export const BRAND = {
  name: "Lis Silva",
  tagline: "Doula & terapeuta",
  topline: `Doula e terapeuta integrativa · ${CONTACT.city}`,
};

export const NAV_LINKS = [
  { label: "A Lis", href: "#sobre" },
  { label: "Doulagem", href: "#servicos" },
  { label: "Terapias", href: "#terapias" },
  { label: "Meu trabalho", href: "#registros" },
  { label: "Valores", href: "#valores" },
];

export const HERO = {
  eyebrow: "Presença, escuta e acolhimento",
  titleLines: ["O seu tempo.", "O seu corpo."],
  titleEmphasis: "O seu cuidado.",
  text: "Acompanhamento na gestação, no parto e no puerpério. Terapias integrativas para encontrar uma pausa e cuidar de si.",
  primaryCta: { label: "Converse com a Lis", href: waLink() },
  secondaryCta: { label: "Conheça os atendimentos", href: "#terapias" },
  image: {
    src: "/assets/gestacao.webp",
    alt: "Lis acompanhando uma gestante ao ar livre, à luz do pôr do sol",
  },
  label: "Cada mulher, uma história.",
  labelSmall: "Um cuidado que respeita a sua.",
};

export const ABOUT = {
  eyebrow: "Prazer, sou a Lis",
  title: "Acolher começa pela escuta.",
  paragraphs: [
    "Sou doula e terapeuta integrativa em Florianópolis. Meu trabalho é oferecer presença, informação e um espaço de cuidado para que cada mulher possa viver seus processos com mais segurança e confiança.",
    "Na gestação, no parto, no puerpério ou em outros momentos de busca por bem-estar, o atendimento parte da sua história e das suas necessidades.",
  ],
  signature: "Lis Silva",
  link: { label: "Conheça o acompanhamento como doula", href: "#servicos" },
  image: { src: "/assets/lis-retrato-circular.png", alt: "Retrato de Lis Silva" },
};

export const JOURNEY = {
  eyebrow: "Doulagem",
  title: "Presença em uma jornada que é sua.",
  intro:
    "O acompanhamento é construído em conversa com você, respeitando seus desejos, suas escolhas e o momento da sua família.",
  steps: [
    {
      number: "01",
      title: "Durante a gestação",
      text: "Encontros para escutar suas dúvidas, conversar sobre o parto, conhecer suas preferências e preparar uma rede de apoio para esse período.",
    },
    {
      number: "02",
      title: "No parto",
      text: "Presença contínua para oferecer apoio emocional, conforto e informações, em diálogo com você e com a equipe responsável pela assistência.",
    },
    {
      number: "03",
      title: "No puerpério",
      text: "Um espaço de acolhimento para atravessar as mudanças dos primeiros dias, falar sobre a experiência vivida e receber apoio nas necessidades desse começo.",
    },
  ],
  whatsappCta: {
    label: "Conversar sobre a doulagem",
    href: waLink(
      "Olá, Lis! Gostaria de saber mais sobre o acompanhamento como doula."
    ),
  },
  nextLink: { label: "Conheça também as terapias", href: "#terapias" },
};

const therapyMessage = (name) =>
  waLink(`Olá, Lis! Gostaria de saber mais sobre ${name.toLowerCase()}.`);

export const THERAPIES = {
  eyebrow: "Terapias integrativas",
  title: "Um tempo para voltar a si.",
  intro:
    "Conheça as práticas oferecidas pela Lis. Cada atendimento começa com uma conversa para compreender o que você busca.",
  actionLabel: "Perguntar sobre esta terapia",
  items: [
    {
      number: "01",
      title: "Mesa radiônica São Miguel Arcanjo",
      text: "Prática energética que utiliza símbolos e instrumentos da radiestesia, dentro de uma abordagem espiritual de autoconhecimento.",
      href: therapyMessage("mesa radiônica são miguel arcanjo"),
    },
    {
      number: "02",
      title: "Apometria",
      text: "Prática espiritual e energética voltada à reflexão sobre questões emocionais e padrões percebidos pela pessoa.",
      href: therapyMessage("apometria"),
    },
    {
      number: "03",
      title: "Massoterapia",
      text: "Toques e manobras de massagem para promover relaxamento, conforto corporal e uma pausa na rotina.",
      href: therapyMessage("massoterapia"),
    },
    {
      number: "04",
      title: "Terapia dos pés",
      text: "Atendimento com foco nos pés, por meio de toques que convidam ao relaxamento e à percepção do corpo.",
      href: therapyMessage("terapia dos pés"),
    },
    {
      number: "05",
      title: "Aromaterapia",
      text: "Uso cuidadoso de aromas e óleos essenciais como parte de uma experiência sensorial de bem-estar.",
      href: therapyMessage("aromaterapia"),
    },
    {
      number: "06",
      title: "Meditação e respiração",
      text: "Práticas guiadas de atenção e respiração para criar um momento de presença e tranquilidade.",
      href: therapyMessage("meditação e respiração"),
    },
  ],
  nextLink: { label: "Veja como começar", href: "#como-funciona" },
  note: "As terapias integrativas são práticas de bem-estar e não substituem acompanhamento médico ou psicológico.",
};

export const WORK = {
  eyebrow: "Meu trabalho",
  title: "Momentos de presença e cuidado.",
  intro:
    "Registros dos encontros, do acompanhamento como doula e dos atendimentos da Lis.",
  items: [
    {
      type: "image",
      landscape: true,
      src: "/assets/preparacao-nascimento.webp",
      alt: "Lis Silva acompanhando uma gestante sentada na bola durante a preparação para o nascimento",
      title: "Preparação para o nascimento",
      caption: "Encontros e práticas durante a gestação.",
    },
    {
      type: "image",
      src: "/assets/preparacao.webp",
      alt: "Acolhimento e orientação com Lis Silva",
      title: "Acolhimento e orientação",
      caption: "Um espaço para conversar e se preparar.",
    },
    {
      type: "image",
      landscape: true,
      src: "/assets/espaco.webp",
      alt: "O espaço de atendimento com Lis Silva",
      title: "O espaço de atendimento",
      caption: "Conforto e privacidade para sua pausa.",
    },
    {
      type: "video",
      src: "/assets/massagem.mp4",
      poster: "/assets/massagem-capa.webp",
      title: "Massagem terapêutica",
      caption: "Conheça um momento do atendimento.",
    },
    {
      type: "video",
      src: "/assets/nascimento.mp4",
      poster: "/assets/nascimento-capa.webp",
      title: "Presença no nascimento",
      caption: "Apoio e acolhimento no início de uma nova etapa.",
    },
    {
      type: "image",
      landscape: true,
      src: "/assets/online.webp",
      alt: "Atendimento online com Lis Silva",
      title: "Atendimento online",
      caption: "Conversa e escuta também a distância.",
    },
  ],
  nextLink: { label: "Conheça os atendimentos e valores", href: "#valores" },
};

const scheduleMessage = (name) =>
  waLink(`Olá, Lis! Conheci seu site e gostaria de agendar ${name}.`);

const packageMessage = (name) =>
  waLink(`Olá, Lis! Conheci seu site e gostaria de agendar o pacote de ${name}.`);

export const PRICES = {
  eyebrow: "Atendimentos e valores",
  title: "Escolha seu momento de cuidado.",
  intro:
    "Sessões individuais e rituais de autocuidado. Consulte a Lis para combinar disponibilidade e detalhes do atendimento.",
  actionLabel: "Agendar este atendimento",
  sessions: [
    {
      title: "Reflexologia podal",
      meta: "40 minutos · R$ 100",
      text: "Toques e pressões nos pés para uma experiência de relaxamento e cuidado.",
      href: scheduleMessage("Reflexologia podal"),
    },
    {
      title: "Reflexologia + aromaterapia",
      meta: "60 minutos · R$ 150",
      text: "Reflexologia podal combinada com aromas cuidadosamente escolhidos para o atendimento.",
      href: scheduleMessage("Reflexologia + aromaterapia"),
    },
    {
      title: "Massagem terapêutica",
      meta: "60 minutos · R$ 150",
      text: "Massagem personalizada de acordo com suas necessidades e preferências, com foco em relaxamento e conforto corporal.",
      href: scheduleMessage("Massagem terapêutica"),
    },
    {
      title: "Massagem + aromaterapia",
      meta: "60 minutos · R$ 170",
      text: "Massagem associada à aromaterapia para uma experiência sensorial de relaxamento.",
      href: scheduleMessage("Massagem + aromaterapia"),
    },
    {
      title: "Ritual dos pés",
      meta: "75 minutos · R$ 190",
      text: "Escalda-pés, aromaterapia, reflexologia podal e relaxamento.",
      href: scheduleMessage("Ritual dos pés"),
    },
    {
      title: "Ritual Reconexão Feminina",
      meta: "90 minutos · R$ 220",
      text: "Massagem terapêutica, aromaterapia, respiração consciente, relaxamento e presença.",
      href: scheduleMessage("Ritual Reconexão Feminina"),
    },
    {
      title: "Ritual Dama da Luz",
      meta: "2 horas · R$ 280",
      text: "Duas horas com escalda-pés, aromaterapia, massagem terapêutica, reflexologia podal, respiração consciente, meditação guiada e acolhimento.",
      href: scheduleMessage("Ritual Dama da Luz"),
      featured: true,
    },
  ],
  packagesTitle: "Pacotes de autocuidado",
  packagesIntro: "Quatro encontros para dar continuidade ao seu cuidado.",
  packageActionLabel: "Consultar este pacote",
  packages: [
    {
      sessionsLabel: "4 sessões",
      title: "Reflexologia + aromaterapia",
      oldPrice: "R$ 600",
      price: "R$ 540",
      perSession: "R$ 135 por sessão",
      href: packageMessage("Reflexologia + aromaterapia"),
    },
    {
      sessionsLabel: "4 sessões",
      title: "Massagem + aromaterapia",
      oldPrice: "R$ 680",
      price: "R$ 600",
      perSession: "R$ 150 por sessão",
      href: packageMessage("Massagem + aromaterapia"),
    },
    {
      sessionsLabel: "4 sessões",
      title: "Ritual Reconexão Feminina",
      oldPrice: "R$ 880",
      price: "R$ 780",
      perSession: "R$ 195 por sessão",
      href: packageMessage("Ritual Reconexão Feminina"),
    },
  ],
  note: "Para doulagem, mesa radiônica e apometria, consulte a proposta diretamente com a Lis.",
  nextLink: { label: "Veja como começar", href: "#como-funciona" },
};

export const APPROACH = {
  eyebrow: "Como começar",
  title: "Uma conversa, no seu tempo.",
  text: "Você não precisa saber exatamente qual atendimento escolher. Conte à Lis o que está vivendo e o que procura; ela explica as possibilidades e combina com você os próximos passos.",
  steps: [
    {
      title: "01 · Envie uma mensagem",
      text: "Diga se o seu interesse é doulagem ou alguma das terapias.",
    },
    {
      title: "02 · Compartilhe suas dúvidas",
      text: "A conversa inicial ajuda a entender o momento e a proposta de atendimento.",
    },
    {
      title: "03 · Combine os detalhes",
      text: "Converse sobre o formato, escolha uma data e confirme os detalhes do atendimento com a Lis.",
    },
  ],
  link: {
    label: "Tirar uma dúvida no WhatsApp",
    href: waLink(
      "Olá, Lis! Conheci seu site e gostaria de encontrar o atendimento ideal para mim."
    ),
  },
};

export const CONTACT_SECTION = {
  eyebrow: "Vamos conversar?",
  title: "O cuidado pode começar por aqui.",
  text: "Se você quer saber mais sobre o acompanhamento como doula ou sobre as terapias, fale com a Lis e conte o que procura.",
  whatsappCta: {
    label: "Conversar no WhatsApp",
    href: waLink(
      "Olá, Lis! Conheci seu site e gostaria de saber mais sobre os atendimentos."
    ),
  },
  instagramCta: { label: "Ver Instagram", href: CONTACT.instagramUrl },
  small: `Atendimento em ${CONTACT.city} · Informações e agendamentos por mensagem`,
};

export const FOOTER = {
  text: "© 2026 Lis Silva · Doula e terapeuta integrativa",
  instagram: { label: CONTACT.instagramHandle, href: CONTACT.instagramUrl },
};
